export default {
  title: {
    id: 'review_funnel_care_block_title',
    defaultMessage: 'Need help?',
  },
  subtitle: {
    id: 'review_funnel_care_block_subtitle',
    defaultMessage:
      "We're available 7 days a week if something went wrong with your order.",
  },
  text: {
    id: 'review_funnel_care_block_text',
    defaultMessage: 'Only 2 minutes to open a help request',
  },
  buttonTitle: {
    id: 'review_funnel_care_block_button_title',
    defaultMessage: 'Get help now',
  },
} as const
